export default "__VITE_ASSET__CZgQyxQw__"